import * as React from 'react';

import { Column } from '../Grid/Column';
import { Row } from '../Grid/Row';

import './index.scss';

interface StackedCardProps {
  children: React.ReactNode;
  header: string;
  props?: React.ReactNode & React.HTMLProps<HTMLElement>;
  className?: string;
}

const StackedCard: React.FunctionComponent<StackedCardProps> = ({
  children,
  header,
  className,
  ...props
}) => (
  <Row className="stacked-card-container" {...props}>
    <Column width={3} className="header-container">
      <h2 className="header">{header}</h2>
    </Column>
    <Column width={9} className="stacked-card">
      {children}
    </Column>
  </Row>
);

export default StackedCard;
